var map = {
	"./01.sun-light.svg": "56f0",
	"./02.sunset-light.svg": "c0ce",
	"./03.sunrise-light.svg": "047e",
	"./04.eclipse-light.svg": "3a24",
	"./05.partial-cloudy-light.svg": "4e25",
	"./05.snowy-cloudy-light.svg": "97d0",
	"./06.rainyday-light.svg": "0fdf",
	"./07.mostly-cloud-light.svg": "d831",
	"./07.snowy-cloud-light.svg": "f50a",
	"./08.full-moon-light.svg": "bec5",
	"./09.half-moon-light.svg": "410a",
	"./10.cloudy-night-light.svg": "a6d6",
	"./11.mostly-cloudy-light.svg": "7265",
	"./12.thunder-light.svg": "6973",
	"./13.thunderstorm-light.svg": "2912",
	"./14.heavy-snowfall-light.svg": "6f21",
	"./15.cloud-light.svg": "ae84",
	"./16.cloudy-night-light.svg": "9e97",
	"./17.cloudy-night-stars-light.svg": "b27a",
	"./18.heavy-rain-light.svg": "a8df",
	"./19.moon-set-light.svg": "5dad",
	"./20.rain-light.svg": "916e",
	"./21.heavy-wind-light.svg": "3b94",
	"./22.snow-light.svg": "a587",
	"./23.hailstrom-light.svg": "7a5e",
	"./24.drop-light.svg": "79b5",
	"./wind.svg": "0847"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c875";